import { SEO } from "@/components/SEO";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const ProducerApply = () => {
  return (
    <>
      <SEO 
        title="Apply for Producer Access | SLAY"
        description="Apply to become a producer on SLAY and start creating events"
      />
      
      <div className="min-h-screen bg-gradient-to-br from-background via-background to-secondary/20 flex flex-col">
        <Header />
        
        <main className="flex-grow container mx-auto px-4 py-12">
          <div className="max-w-2xl mx-auto text-center">
            <h1 className="text-4xl font-bold bg-gradient-to-r from-primary via-purple-500 to-pink-500 bg-clip-text text-transparent mb-4">
              Become a SLAY Producer
            </h1>
            <p className="text-lg text-muted-foreground mb-8">
              Join our community of event producers and start creating amazing LGBTQIA+ events.
            </p>

            <div className="rounded-2xl border border-border bg-card p-8 mb-8">
              <h2 className="text-2xl font-bold mb-4">What You'll Get</h2>
              <ul className="text-left space-y-3 mb-6">
                <li className="flex items-start gap-2">
                  <span className="text-primary">✓</span>
                  <span>Full event management dashboard</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-primary">✓</span>
                  <span>Ticketing and payment processing</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-primary">✓</span>
                  <span>Analytics and reporting tools</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-primary">✓</span>
                  <span>Marketing and promotional support</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-primary">✓</span>
                  <span>Direct payout management</span>
                </li>
              </ul>

              <p className="text-muted-foreground mb-6">
                To apply for producer access, please contact our team at{' '}
                <a href="mailto:support@slay.events" className="text-primary hover:underline">
                  support@slay.events
                </a>
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button asChild>
                  <a href="mailto:support@slay.events?subject=Producer Access Application">
                    Apply Now
                  </a>
                </Button>
                <Button variant="outline" asChild>
                  <Link to="/producers/login">
                    Back to Login
                  </Link>
                </Button>
              </div>
            </div>

            <p className="text-sm text-muted-foreground">
              Already have producer access?{' '}
              <Link to="/producers/login" className="text-primary hover:underline">
                Sign in here
              </Link>
            </p>
          </div>
        </main>
        
        <Footer />
      </div>
    </>
  );
};

export default ProducerApply;
